import { ArticleVariantType } from '@buildwise/pages/knowledge/components/ArticleBox';
import { SxProps, Theme, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';
import { highlightSearchKeyword } from 'utility/helpers';

type PostTitleProps = {
  searchKeyword?: string;
  title: string;
  sx?: SxProps<Theme>;
  variant: ArticleVariantType;
};

function PostTitle({ searchKeyword = '', title, variant, sx }: PostTitleProps) {
  if (title) {
    return (
      <ArticleTitle
        variant="h5"
        className={variant}
        sx={sx}
        {...(searchKeyword
          ? {
              dangerouslySetInnerHTML: {
                __html: highlightSearchKeyword(title, searchKeyword),
              },
            }
          : {
              children: title,
            })}
      />
    );
  }

  return null;
}

export const ArticleTitle = styled(Typography)(({ theme }) => ({
  wordWrap: 'break-word',
  fontSize: 18,
  fontWeight: 700,
  lineHeight: '29px',
  color: theme.palette.custom.tuna,
  '& .highlight': {
    backgroundColor: `${theme.palette.custom.paleGold} !important`,
  },
  '& a': {
    color: theme.palette.custom.link,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  '&.related-post': {
    fontSize: 14,
    lineHeight: '20px',
  },
}));

export default memo(PostTitle);
